import { render, staticRenderFns } from "./CommentCallout.vue?vue&type=template&id=09770e68"
import script from "./CommentCallout.vue?vue&type=script&lang=js"
export * from "./CommentCallout.vue?vue&type=script&lang=js"
import style0 from "./CommentCallout.vue?vue&type=style&index=0&id=09770e68&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports